import React from 'react';
import { PhoneIcon, ShieldCheckIcon, AwardIcon } from 'lucide-react';
export function TopBar() {
  return <div className="bg-[#1A1A1A] text-white py-0 px-6 border-b border-white/5 text-[11px] md:text-sm font-bold uppercase tracking-[0.1em]" data-id="element-151">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:h-14" data-id="element-152">
        <div className="flex items-center justify-center gap-8 w-full md:w-auto py-4 md:py-0 border-b border-white/5 md:border-none" data-id="element-153">
          <div className="flex items-center gap-2" data-id="element-154">
            <PhoneIcon className="w-4 h-4 text-white/60" data-id="element-155" />
            <a href="tel:4107776984" className="hover:text-[#6B0D24] transition-colors" data-id="element-156">
              410-777-6984
            </a>
          </div>
          <div className="hidden md:block text-white/60" data-id="element-157">MHIC # 133888</div>
        </div>

        <div className="flex flex-row items-center w-full md:w-auto h-full" data-id="element-158">
          <a href="/contact" className="bg-[#6B0D24] hover:bg-[#5A0B1E] text-white px-4 md:px-10 py-4 md:py-0 md:h-14 flex items-center justify-center transition-colors w-1/2 md:w-auto border-r border-white/5 md:border-none" data-id="element-159">
            Get a Quote
          </a>
          <a href="/cart" className="bg-[#3D0815] hover:bg-[#2D0610] text-white px-4 md:px-12 py-4 md:py-0 md:h-14 flex items-center justify-center transition-colors w-1/2 md:w-auto" data-id="element-160">
            Cart
          </a>
        </div>
      </div>
    </div>;
}